/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccessTokenDetailsDTO } from '../models/AccessTokenDetailsDTO';
import type { AccessTokenRefresh } from '../models/AccessTokenRefresh';
import type { UserLogin } from '../models/UserLogin';
import { request as __request } from '../core/request';

export class AccessTokenService {

    /**
     * @param requestBody
     * @returns AccessTokenDetailsDTO OK
     * @throws ApiError
     */
    public static async accessTokenCreateAccessToken(
        requestBody?: UserLogin,
    ): Promise<AccessTokenDetailsDTO> {
        const result = await __request({
            method: 'POST',
            path: `/Auth/AccessToken`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns AccessTokenDetailsDTO OK
     * @throws ApiError
     */
    public static async accessTokenRefreshAccessToken(
        requestBody?: AccessTokenRefresh,
    ): Promise<AccessTokenDetailsDTO> {
        const result = await __request({
            method: 'POST',
            path: `/Auth/RefreshToken`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
            },
        });
        return result.body;
    }

}